import React, { Component } from "react";
// import ReactDOM from "react-dom";

class About extends Component {

  render() {
    return <div> ABOUT 3 Ecologgiiiesssss </div>;
  }
}

export default About;
